

import React from 'react';

require('./PhasePositionsDemo.js');


export class InteractivesWrapper extends React.Component {

  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {

    let element = this.ref.current;
    element.style.width = '667px';
    element.style.height = '375px';

    let interactive = new window.astroUNL.lib.PhasePositionsDemo(element);
    interactive.reset();

    element.addEventListener('stateChanged', (e) => {
      this.props.onStateChanged(e.detail);
    });

    this.props.onInteractiveReady(interactive);
  }

  componentWillUnmount() {
    // TODO: cancel ref request if not yet finished or ignore result
  }

  render() {
    return (
      <div style={{position: 'sticky', top: '0px', left: '0px', width: '100%', zIndex: '999'}}>
        <div style={{padding: '1em', backgroundColor: '#aaa'}}>
            <div ref={this.ref} style={{margin: '1em auto'}}></div>
        </div>
        <div style={{borderTop: '1px solid lightgray', height: '1em', background: 'linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.0)'}} />
      </div>
    );
  }

}



